import {
    CommandResponse,
    RevisionedCommandResponse,
    StudyPopulation,
    toStudyPopulation,
} from '@faro/study-designer-model';
import axios from 'axios';
import { RevisionQueryParameter, StudyPathParameter } from '../parameter';

export type StudyPopulationPathParameters = StudyPathParameter;
export type StudyPopulationQueryParameters = RevisionQueryParameter;

/**
 * Client responsible for accessing the backend entity services
 */
export const studyPopulationClient = {
    list: (
        request?: StudyPopulationPathParameters & StudyPopulationQueryParameters,
        signal?: AbortSignal
    ): Promise<StudyPopulation[]> => {
        const { studyId, ...query } = request ?? {};
        return axios
            .get(`/api/study-designer/studies/${studyId}/study-populations`, {
                params: query,
                signal,
            })
            .then(response => response.data?.map(toStudyPopulation) ?? []);
    },
    update: (request: StudyPopulation): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .put(`/api/study-designer/studies/${request.studyId}/study-populations/${request.id}`, request)
            .then(response => response.data);
    },
};
